import { render, staticRenderFns } from "./add-printer.vue?vue&type=template&id=73fa065e&scoped=true"
import script from "./add-printer.ts?vue&type=script&lang=ts&external"
export * from "./add-printer.ts?vue&type=script&lang=ts&external"
import style0 from "./add-printer.scoped.scss?vue&type=style&index=0&id=73fa065e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa065e",
  null
  
)

export default component.exports